<template>
  <div>
    <head-top :isShow="isShow"></head-top>
    <!-- 内容 start -->
    <div class="pay-page-title">
      <div class="pay-page-title-main">订单支付</div>
    </div>
    <div class="description-first-bg"></div>
    <div class="pay-page-content">
      <div class="pay-page-content-desc">
        <div class="order-desc">
          <p>订单提交成功，请尽快付款！订单号：{{orderInfo.order_sn}}</p>
          <p>标题：{{orderInfo.title}}</p>
          <p>手机号码：{{orderInfo.phone}}</p>
        </div>
        <div class="order-money">
          <p>
            应付金额
            <span>{{orderInfo.total_price}}</span> 元
          </p>
          <p>产品：{{orderInfo.goods_name}}</p>
        </div>
      </div>
    </div>

    <div class="pay-inner">
      <h2 v-text="$route.query.type==true?'微信支付':'支付宝支付'"></h2>
      <div class="pay-inner-box">
        <div class="pay-inner-box-left">
          <div class="code-img">
            <img :src="urlEwm" width="220" />
          </div>
          <p>请使用<span v-text="$route.query.type==true?'微信':'支付宝'"></span>扫描上方</p>
          <p>二维码以完成支付</p>
          <p class="money">¥{{orderInfo.total_price}}</p>
        </div>
        <div class="pay-inner-box-right">
          <img v-if="$route.query.type==true" src="../../static/img/ts-img/wx-pay-img.png" width="372" />
          <img   v-else-if="$route.query.type==false" src="../../static/img/ts-img/alipay.png" width="372" />
        </div>
      </div>
      <div class="choose-other-method" @click="getReplace">
        <i>
          <img src="../../static/img/ts-img/blue-left-arrow.png" width="12" />
        </i>选择其他支付方式
      </div>
    </div>
    <!-- 内容 end -->
    <foot-bottom></foot-bottom>
<!--   -->
    <div class="testing-popup" v-show="orderStatus!==0">
        <div class="testing-inner">
          <div class="close-btn" @click="$route.push('/reportDownload')"><img src="../../static/img/ts-img/close-icon.png" width="24"></div>
          <div class="testing-inner-main">
            <i @click="closeFun"><img src="../../static/img/ts-img/testing-icon.png" width="100"></i>
            <div class="testing-inner-main-txt">
              <h2>开始检测</h2>
              <p>检测期间可以关闭浏览器以及电脑
                此窗口 <span>{{ms}}s</span> 后自动关闭</p>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import headTop from "../components/header/head-top";
import footBottom from "../components/footer/foot-bottom";
import productDetail from "../components/system-com/system-detail";
import productReport from "../components/system-com/product-report";
import productEvaluate from "../components/system-com/product-evaluate";
import tool from "./../assets/js/tool";
export default {
  name: "pay-page",
  data() {
    return {
      isShow: false,
      urlEwm: "",
      orderInfo: [], //订单信息
      tStatus: null, //定时器
      orderStatus:0,
      ms:5
    };
  },
  components: {
    headTop,
    footBottom
  },
  created() {
    this.getPay();
  },
  methods: {
    getPay() {
      var queryParams = {
        order_sn: this.$route.query.id,
        pay_way: this.$route.query.type == true ? 1 : 3
      };
      tool.postData("pay", queryParams, res => {
        this.orderInfo = res.data.data.order_detail;
        console.log(res.data.data.order_detail)
        var baseUrl =
          "https://cnkijc.cn" !== window.location.href
            ? "https://cnkijc.cn"
            : window.location.host;
        this.urlEwm = baseUrl + "/qrcode.php?data=" + res.data.data.code_url;
        this.tStatus=setInterval(this.getOrderStatus,2000);
        console.log(baseUrl)
      });
    },
    getReplace() {
      this.$router.replace({
        path: "/payPage",
        query: {
          id: this.$route.query.id,
          type: !this.$route.query.type
        }
      });
    },
    getOrderStatus() {
      var num=1
      console.log(num++)
      var queryParams = {
        order_sn: this.$route.query.id
      };
      tool.postData("order_status", queryParams, res => {
        this.orderStatus=res.data.data.order_status
        // console.log(this.orderStatus)
      });
    },
    closeFun(){
      this.orderStatus!==0
    }
  },
  destroyed(){
    clearInterval(this.tStatus)
  },
  watch:{
    orderStatus:function(o,v){
      if(o!==0){
          clearInterval(this.tStatus)
          this.tStatus=setInterval(()=>{
            this.ms--
          },1000)
      }
    },
    ms:function(o){
      if(o==0){
        clearInterval(this.tStatus)
        this.$router.push('/reportDownload')
      }
    },
    '$route':function(o,v){
      this.getPay()
    }
  }

};
</script>

<style scoped lang="scss">
@import "../assets/style/common";
.description-first-bg {
  width: 100%;
  height: 80px;
  background: url("../../static/img/nav.png");
}
.pay-page-title {
  width: 100%;
  height: 53px;
  background-color: #eff4ff;
  .pay-page-title-main {
    width: $box-width;
    margin: 0 auto;
    line-height: 53px;
    @include font(26px, #3b6bda);
  }
}
.pay-page-content {
  width: $box-width;
  margin: 0 auto;
  .pay-page-content-desc {
    @include flex;
    padding: 23px 0;
    .order-desc {
      p {
        @include font(18px, #333);
        line-height: 38px;
      }
    }
    .order-money {
      p {
        text-align: right;
        @include font(18px, #333);
        line-height: 38px;
        span {
          @include font(24px, #ee4848);
        }
      }
    }
  }
}
.pay-inner {
  width: $box-width;
  padding: 0 17px 40px;
  margin: 0 auto 200px;
  box-sizing: border-box;
  box-shadow: 0 2px 5px 4px #c2c2c2;
  h2 {
    @include font(26px, #333);
    line-height: 70px;
  }
  .pay-inner-box {
    display: flex;
    .pay-inner-box-left {
      width: 50%;
      text-align: center;
      .code-img {
        margin-bottom: 10px;
      }
      p {
        @include font(18px, #666);
        line-height: 30px;
      }
      .money {
        @include font(30px, #f99544);
        margin-top: 7px;
      }
    }
  }
  .choose-other-method {
    display: flex;
    align-items: center;
    @include font(20px, #3b6bda);
    margin-top: 27px;
    margin-left: 10px;
    cursor: pointer;
    i {
      margin-right: 5px;
    }
  }
}
.testing-popup {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  .testing-inner {
    width: 492px;
    height: 184px;
    background-color: #fff;
    border-radius: 10px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 20px;
    box-sizing: border-box;
    .close-btn {
      width: 100%;
      text-align: right;
    }
    .testing-inner-main {
      display: flex;
      align-items: center;
      width: 376px;
      margin: 0 auto;
      .testing-inner-main-txt {
        margin-left: 25px;
        h2 {
          @include font(30px, #53ba64);
          font-weight: bold;
        }
        p {
          @include font(16px, #999);
          line-height: 25px;
          margin-top: 10px;
          span {
            color: #3b6bda;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/pay-page.vue